import { useEffect, useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import ErrorBoundary from "../../shared/components/error-boundary/ErrorBoundary";
import ProjectStatisticsTabs from "./tabs/ProjectStatisticsTabs";
import CompanyProjectStatistics from "./components/companyProjectsStatistics";
import DepartmentProjectStatistics from "./components/departmentProjectsStatistics";
import ProjectStatistics from "./components/projectStatistics";
import IndividualProjectStatistics from "./components/individualProjectsStatistics";
import { useAppContext } from "../../shared/functions/Context";
import useTitle from "../../shared/hooks/useTitle";
import Loading from "../../shared/components/loading/Loading";

const Statistics = observer(() => {
    useTitle("Projects Statistics and Reports");
    const { api } = useAppContext();
    const [selectedTab, setSelectedTab] = useState(localStorage.getItem("project-s-selected-tab") || "company-tab");
    const [loading, setLoading] = useState(false);
    const firstRenderRef = useRef(true);

    useEffect(() => {
        if (!firstRenderRef.current) return;

        const loadData = async () => {
            setLoading(true);
            await api.user.getAll();
            setLoading(false);
        };

        loadData();
        firstRenderRef.current = false;
    }, [api.user]);

    if (loading) return <Loading />;

    return (
        <ErrorBoundary>
            <div className="statistics">
                <ProjectStatisticsTabs selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
                <div className="content">
                    {selectedTab === "company-tab" && <CompanyProjectStatistics />}
                    {selectedTab === "department-tab" && <DepartmentProjectStatistics />}
                    {selectedTab === "individual-tab" && <IndividualProjectStatistics />}
                    {selectedTab === "project-tab" && <ProjectStatistics />}
                </div>
            </div>
        </ErrorBoundary>
    );
});

export default Statistics;
